module.exports = "/images/logo-small.svg";